module.exports = __webpack_public_path__ + "media/images/riders/TAHNEE_SEAGRAVE-43d2ec26f588034909cfbcedffc915f7.png";